/**
 * Route definition for /acknowledgements
 * Renders the AcknowledgementsContainer to display dependency credits.
 *
 * @module routes/acknowledgements
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import AcknowledgementsContainer from "@/containers/Acknowledgements";

export const Route = createFileRoute('/$locale/acknowledgements')({
    component: Acknowledgements,
});

/**
 * Acknowledgements page component.
 * Renders the acknowledgements container showing open-source dependencies.
 *
 * @returns {React.ReactElement}
 */
function Acknowledgements() {

    return (
        <>
            <AcknowledgementsContainer/>
        </>
    );
}
